import { makeStyles } from '@material-ui/core';
export default makeStyles((theme) => ({
  profileBox: {
    height: 'calc(100vh - 56px)',
  },
  mainHeader: {},
  mainHeaderText: {
    fontSize: 29,
    color: theme.palette.warning.contrastText,
    marginBottom: 30,
    fontWeight: 700,
    letterSpacing: 0.3,
    '@media (max-width: 525px)': {
      fontSize: 20,
    },
  },
  profileCont: {
    height: 'calc(100vh - 210px)',
    overflow: 'hidden auto',
    background: theme.palette.primary.contrastText,
    borderRadius: 11,
    padding: '30px 30px 30px 45px',
    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
      backgroundColor: '#1EA59A',
      width: '0.6em',
      visibility: 'hidden',
    },
    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
      borderRadius: 8,
      backgroundColor: theme.palette.warning.main,
      minHeight: 24,
      border: '1px solid #1EA59A',
      visibility: 'hidden',
    },
    '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
      backgroundColor: '#2B2B2B',
    },
  },
  tabsContainer: {
    borderBottom: '1px solid #DEDEDE',
    height: 42,
    minHeight: 'auto',
    '& .MuiTabs-flexContainer': {
      height: 42,
      minHeight: 'auto',
    },
    '& .MuiTab-textColorPrimary': {
      color: theme.palette.warning.contrastText,
    },
    '& .MuiTab-root': {
      height: 42,
      minHeight: 'auto',
    },
    '& .MuiTab-textColorPrimary.Mui-selected': {
      background: '#FF68299C',
      height: 42,
      minHeight: 'auto',
      // borderRadius: '4px 0'
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      color: theme.palette.primary.contrastText,
    },
    '& .MuiTab-wrapper': {
      fontSize: 16,
    },
    '& .MuiTabs-indicator': {
      background: theme.palette.secondary.main,
    },
  },
  tabPanelContainer: {
    paddingTop: 25,
  },
}));
